import { render, staticRenderFns } from "./TransportTypeSelect.vue?vue&type=template&id=ce585140"
import script from "./TransportTypeSelect.vue?vue&type=script&lang=ts"
export * from "./TransportTypeSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports